var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "customerInvoiceDetail" }, [
    _c(
      "div",
      {
        staticStyle: {
          padding: "0 10px",
          height: "calc(100vh - 140px)",
          "overflow-y": "auto",
        },
      },
      [
        _c(
          "el-form",
          {
            ref: "invoiceDetailRef",
            attrs: {
              model: _vm.invoiceDetail,
              "label-position": "top",
              size: "small",
              disabled: _vm.viewType === 1,
            },
          },
          [
            _c(
              "el-card",
              {
                staticClass: "box-card",
                staticStyle: { "margin-bottom": "10px" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("collectionCenter.basicInformation"))
                      ),
                    ]),
                    _vm.viewType !== 1
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "30px" },
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function ($event) {
                                _vm.popoverVisible = !_vm.popoverVisible
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("mdfeTranslate.OneClickFillIn")) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "el-popover",
                      {
                        attrs: { placement: "bottom", trigger: "manual" },
                        model: {
                          value: _vm.popoverVisible,
                          callback: function ($$v) {
                            _vm.popoverVisible = $$v
                          },
                          expression: "popoverVisible",
                        },
                      },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "el-form",
                              {
                                ref: "inputFormRef",
                                attrs: {
                                  model: _vm.inputForm,
                                  size: "small",
                                  "label-position": "top",
                                },
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "mdfeTranslate.InvoiceCNPJ"
                                      ),
                                      prop: "cnpj",
                                      rules: [
                                        {
                                          required: true,
                                          validator: _vm.checkcnpj,
                                          trigger: ["blur", "change"],
                                        },
                                      ],
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "300px" },
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "collectionCenter.pleaseInput"
                                        ),
                                      },
                                      model: {
                                        value: _vm.inputForm.cnpj,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.inputForm, "cnpj", $$v)
                                        },
                                        expression: "inputForm.cnpj",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "mdfeTranslate.StateAbbreviationUF"
                                      ),
                                      prop: "state",
                                      rules: [
                                        {
                                          required: true,
                                          message: _vm.$t(
                                            "collectionCenter.pleaseInput"
                                          ),
                                          trigger: ["blur", "change"],
                                        },
                                      ],
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "300px" },
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "placeOrder.pleaseInput"
                                          ),
                                          clearable: "",
                                          filterable: "",
                                        },
                                        on: { change: _vm.stateChangeOption },
                                        model: {
                                          value: _vm.inputForm.state,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.inputForm,
                                              "state",
                                              $$v
                                            )
                                          },
                                          expression: "inputForm.state",
                                        },
                                      },
                                      _vm._l(
                                        _vm.senderStateList,
                                        function (item) {
                                          return _c("el-option", {
                                            key: item.id,
                                            attrs: {
                                              label: item.shortName,
                                              value: item.shortName,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticStyle: { "text-align": "right" } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "small" },
                                    on: {
                                      click: function ($event) {
                                        _vm.popoverVisible = false
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("collectionCenter.close"))
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary", size: "small" },
                                    on: { click: _vm.saveInput },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("collectionCenter.Confirm"))
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 10 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("mdfeTranslate.CustomerCode"),
                                  prop: "customerId",
                                  rules: [
                                    {
                                      required: true,
                                      message: _vm.$t(
                                        "collectionCenter.pleaseInput"
                                      ),
                                      trigger: ["blur", "change"],
                                    },
                                  ],
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "basicData.PleaseSelect"
                                      ),
                                      filterable: "",
                                      clearable: "",
                                      remote: "",
                                      "reserve-keyword": "",
                                      disabled: _vm.viewType === 2,
                                      "remote-method": _vm.getCustomerOption,
                                    },
                                    on: {
                                      "visible-change":
                                        _vm.getCustomerOptionDialog,
                                      change: _vm.customerChange,
                                    },
                                    model: {
                                      value: _vm.invoiceDetail.customerId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.invoiceDetail,
                                          "customerId",
                                          $$v
                                        )
                                      },
                                      expression: "invoiceDetail.customerId",
                                    },
                                  },
                                  _vm._l(_vm.customerOption, function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label:
                                          item.username + "（" + item.id + "）",
                                        value: item.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("mdfeTranslate.InvoiceCNPJ"),
                                  prop: "invoiceCnpj",
                                  rules: [
                                    {
                                      required: true,
                                      validator: _vm.checkcnpj,
                                      trigger: ["blur", "change"],
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "collectionCenter.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.invoiceDetail.invoiceCnpj,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.invoiceDetail,
                                        "invoiceCnpj",
                                        $$v
                                      )
                                    },
                                    expression: "invoiceDetail.invoiceCnpj",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("mdfeTranslate.InvoiceIE"),
                                  prop: "invoiceIe",
                                  rules: [
                                    {
                                      required: true,
                                      validator: _vm.ieNumber,
                                      trigger: ["blur", "change"],
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "collectionCenter.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.invoiceDetail.invoiceIe,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.invoiceDetail,
                                        "invoiceIe",
                                        $$v
                                      )
                                    },
                                    expression: "invoiceDetail.invoiceIe",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "mdfeTranslate.CompanyAbbreviation"
                                  ),
                                  prop: "companyShortName",
                                  rules: [
                                    {
                                      required: false,
                                      message: _vm.$t(
                                        "collectionCenter.pleaseInput"
                                      ),
                                      trigger: ["blur", "change"],
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "collectionCenter.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.invoiceDetail.companyShortName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.invoiceDetail,
                                        "companyShortName",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "invoiceDetail.companyShortName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "customerManagements.AccountName"
                                  ),
                                  prop: "customerName",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: "",
                                    placeholder: _vm.$t(
                                      "collectionCenter.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.invoiceDetail.customerName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.invoiceDetail,
                                        "customerName",
                                        $$v
                                      )
                                    },
                                    expression: "invoiceDetail.customerName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "mdfeTranslate.CompanyFullName"
                                  ),
                                  prop: "companyFullName",
                                  rules: [
                                    {
                                      required: true,
                                      message: _vm.$t(
                                        "collectionCenter.pleaseInput"
                                      ),
                                      trigger: ["blur", "change"],
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "collectionCenter.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.invoiceDetail.companyFullName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.invoiceDetail,
                                        "companyFullName",
                                        $$v
                                      )
                                    },
                                    expression: "invoiceDetail.companyFullName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "el-card",
              {
                staticClass: "box-card",
                staticStyle: { "margin-bottom": "10px" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.$t("seller.addressInfo")))])]
                ),
                _c(
                  "div",
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 10 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("basicData.zipCode"),
                                  prop: "postalCode",
                                  rules: [
                                    {
                                      required: true,
                                      validator: _vm.checkPostcode,
                                      trigger: ["blur", "change"],
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "collectionCenter.pleaseInput"
                                    ),
                                  },
                                  on: { change: _vm.changePostalCode },
                                  model: {
                                    value: _vm.invoiceDetail.postalCode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.invoiceDetail,
                                        "postalCode",
                                        $$v
                                      )
                                    },
                                    expression: "invoiceDetail.postalCode",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "mdfeTranslate.StateAbbreviationUF"
                                  ),
                                  prop: "uf",
                                  rules: [
                                    {
                                      required: true,
                                      message: _vm.$t(
                                        "collectionCenter.pleaseInput"
                                      ),
                                      trigger: ["blur", "change"],
                                    },
                                  ],
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "placeOrder.pleaseInput"
                                      ),
                                      clearable: "",
                                      filterable: "",
                                    },
                                    on: { change: _vm.stateChangeOption },
                                    model: {
                                      value: _vm.invoiceDetail.uf,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.invoiceDetail, "uf", $$v)
                                      },
                                      expression: "invoiceDetail.uf",
                                    },
                                  },
                                  _vm._l(_vm.senderStateList, function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.shortName,
                                        value: item.shortName,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("collectionCenter.city"),
                                  prop: "city",
                                  rules: [
                                    {
                                      required: true,
                                      message: _vm.$t(
                                        "collectionCenter.pleaseInput"
                                      ),
                                      trigger: ["blur", "change"],
                                    },
                                  ],
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "formTable",
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "placeOrder.pleaseChoose"
                                      ),
                                      "remote-method": _vm.getSenderCity,
                                      filterable: "",
                                      remote: "",
                                      "reserve-keyword": "",
                                    },
                                    on: {
                                      "visible-change": function ($event) {
                                        return _vm.cityOptionOpen()
                                      },
                                    },
                                    model: {
                                      value: _vm.invoiceDetail.city,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.invoiceDetail, "city", $$v)
                                      },
                                      expression: "invoiceDetail.city",
                                    },
                                  },
                                  _vm._l(_vm.cityList, function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.name,
                                        value: item.name,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("mdfeTranslate.Street"),
                                  prop: "street",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "collectionCenter.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.invoiceDetail.street,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.invoiceDetail, "street", $$v)
                                    },
                                    expression: "invoiceDetail.street",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("placeOrder.detailedAddress"),
                                  prop: "detailedAddress",
                                  rules: [
                                    {
                                      required: true,
                                      message: _vm.$t(
                                        "collectionCenter.pleaseInput"
                                      ),
                                      trigger: ["blur", "change"],
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "collectionCenter.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.invoiceDetail.detailedAddress,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.invoiceDetail,
                                        "detailedAddress",
                                        $$v
                                      )
                                    },
                                    expression: "invoiceDetail.detailedAddress",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "mdfeTranslate.SupplementalAddress"
                                  ),
                                  prop: "supplementaryAddress",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "collectionCenter.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value:
                                      _vm.invoiceDetail.supplementaryAddress,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.invoiceDetail,
                                        "supplementaryAddress",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "invoiceDetail.supplementaryAddress",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("driver.modalNeighborhood"),
                                  prop: "neighbourhood",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "collectionCenter.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.invoiceDetail.neighbourhood,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.invoiceDetail,
                                        "neighbourhood",
                                        $$v
                                      )
                                    },
                                    expression: "invoiceDetail.neighbourhood",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("placeOrder.HouseNumber"),
                                  prop: "houseNumber",
                                  rules: [
                                    {
                                      required: false,
                                      message: _vm.$t(
                                        "collectionCenter.pleaseInput"
                                      ),
                                      trigger: ["blur", "change"],
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "collectionCenter.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.invoiceDetail.houseNumber,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.invoiceDetail,
                                        "houseNumber",
                                        $$v
                                      )
                                    },
                                    expression: "invoiceDetail.houseNumber",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("mdfeTranslate.IBGECode"),
                                  prop: "cityCode",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: "",
                                    placeholder: _vm.$t(
                                      "collectionCenter.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.invoiceDetail.cityCode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.invoiceDetail,
                                        "cityCode",
                                        $$v
                                      )
                                    },
                                    expression: "invoiceDetail.cityCode",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "orderCenterCont.telephoneNumber"
                                  ),
                                  prop: "phoneNumber",
                                  rules: [
                                    {
                                      required: true,
                                      message: _vm.$t(
                                        "collectionCenter.pleaseInput"
                                      ),
                                      trigger: ["blur", "change"],
                                    },
                                    {
                                      validator: _vm.MobilePhoneNumber,
                                      trigger: ["blur", "change"],
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "collectionCenter.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.invoiceDetail.phoneNumber,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.invoiceDetail,
                                        "phoneNumber",
                                        $$v
                                      )
                                    },
                                    expression: "invoiceDetail.phoneNumber",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("orderDetails.email"),
                                  prop: "email",
                                  rules: [
                                    {
                                      required: true,
                                      message: _vm.$t(
                                        "collectionCenter.pleaseInput"
                                      ),
                                      trigger: ["blur", "change"],
                                    },
                                    {
                                      validator: _vm.E_Mail,
                                      trigger: ["blur", "change"],
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "collectionCenter.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.invoiceDetail.email,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.invoiceDetail, "email", $$v)
                                    },
                                    expression: "invoiceDetail.email",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticStyle: {
          "text-align": "right",
          padding: "20px",
          "border-top": "1px solid #ccc",
        },
      },
      [
        _vm.viewType !== 1
          ? _c(
              "el-button",
              {
                attrs: { size: "small", type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.onSubmitDetailForm()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("collectionCenter.submit")))]
            )
          : _vm._e(),
        _c(
          "el-button",
          {
            attrs: { size: "small", plain: "" },
            on: {
              click: function ($event) {
                return _vm.onCloseDetailWindow()
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("orderCenterCont.back")))]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }